import { GridColType } from '@mui/x-data-grid';
import { formatMoneyString } from './format-money-string';

export const MoneyValueZeroOnRequestFormatter = (
  x: number | null | undefined,
  zeroOnRequest: boolean = true,
): string => {
  if (zeroOnRequest && x === 0) return 'Auf Anfrage';
  const formattedNumber = formatMoneyString(x || 0);
  return formattedNumber || 'N/A';
};

export const MoneyValueZeroFormatter = (
  x: number | null | undefined,
  zeroOnRequest: boolean = true,
): string => {
  const formattedNumber = formatMoneyString(x || 0);
  return formattedNumber || 'N/A';
};

export const MoneyValueZeroOnRequestProps: {
  type: GridColType;
  valueFormatter: (x: never) => string;
  width: number;
} = {
  type: 'number',
  valueFormatter: MoneyValueZeroOnRequestFormatter,
  width: 120,
};

export const MoneyValueZeroProps: {
  type: GridColType;
  valueFormatter: (x: never) => string;
  width: number;
} = {
  type: 'number',
  valueFormatter: MoneyValueZeroFormatter,
  width: 120,
};

export const MoneyValueFormatter = (x: number | null | undefined): string => {
  const formattedNumber = formatMoneyString(x || 0);
  return formattedNumber || 'N/A';
};

export const MoneyValueProps: {
  type: GridColType;
  valueFormatter: (x: never) => string;
  width: number;
} = {
  type: 'number',
  valueFormatter: MoneyValueFormatter,
  width: 120,
};
